<template>
  <!--Start Page Banner-->
  <div class="page-banner-area bg-1">
    <div class="container">
      <div class="page-banner-content">
        <h1>Mentor Mentee</h1>
        <ul>
          <li><a href="/">Home</a></li>
          <li>Student Corner</li>
          <li>Mentor Mentee</li>
        </ul>
      </div>
    </div>
  </div>
  <!--End Page Banner-->

  <!--Start Mentor-Mentee Area-->

  <div class="academic-area pt-70 pb-10">
    <div class="container">
      <div class="section-title">
        <h2>MENTOR - MENTEE PROGRAM</h2>
      </div>
      <div class="row justify-content-center">
        <div
          class="col-lg-6 col-md-6"
          data-aos-duration="1200"
          data-aos-delay="200"
          data-aos-once="true"
        >
          <div class="single-academics-card">
            <div class="academic-top-content">
              <i class="flaticon-college-graduation"></i>
              <a href="#">
                <h3>Vision</h3>
              </a>
            </div>
            <p>
              It's a program aimed at promoting a positive learning environment
              and enhancing the overall educational experience
            </p>
          </div>
        </div>
        <div
          class="col-lg-6 col-md-6"
          data-aos-duration="1200"
          data-aos-delay="400"
          data-aos-once="true"
        >
          <div class="single-academics-card">
            <div class="academic-top-content">
              <i class="flaticon-graduation"></i>
              <a href="#">
                <h3>Mission</h3>
              </a>
            </div>
            <p>
              The program aims to provide support, guidance, and resources to
              students, helping them navigate academic and personal challenges
              while also facilitating communication and understanding between
              students and faculty.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="academics-details-area pt-8 pb-10">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="academics-details">
            <div class="details">
              <h2>About Mentor-Mentee Program</h2>
              <p>
                The Mentor-Mentee Program is an essential component for a
                successful career as it bridges the gap between faculty and
                students. A mentor plays a vital role in nurturing students and
                has a positive impact on their persistence and academic
                achievement. Mentoring provides students with emotional and
                instrumental support, guidance, encouragement, and a better
                environment in college. A mentee can approach her mentor for
                both educational and personal guidance.
              </p>
              <p>
                We have been providing tips on studying, personal counseling,
                guidance regarding career choices, and achieving success in
                university examinations. We have also been supporting mentees
                with precise information on courses, fees, reviews, the college
                admission process, scholarships, etc. The scheme has become very
                successful in bridging the gap between teachers and students. It
                has become instrumental in fostering harmonious relationships
                between the learner, her family, and the institution at large.
                It has definitely created an atmosphere of conviction and faith
                about the alma mater.
              </p>
              <div class="details-images">
                <div class="row">
                  <div class="col-lg-4 col-md-4">
                    <img
                      src="/vf/images/student_corner/mentor_mentee/1.png"
                      alt="Image"
                    />
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <img
                      src="/vf/images/student_corner/mentor_mentee/2.png"
                      alt="Image"
                    />
                  </div>
                  <div class="col-lg-4 col-md-4">
                    <img
                      src="/vf/images/student_corner/mentor_mentee/3.png"
                      alt="Image"
                    />
                  </div>
                </div>
              </div>
            </div>
            <hr />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="academics-details-area pt-10 pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="regiStartion-and-fee">
            <h3>Program Details</h3>
            <p>
              The mentoring-mentee system at VPGGC is a structured program in
              which each faculty member is assigned the task of mentoring about
              35-40 students. First-year students will have mentors from their
              respective departments, and as they progress through subsequent
              years, they will be assigned to succeeding faculty members from
              those particular years.
            </p>
            <p>
              We provide counseling to students through personal attention and
              regular dialogues during their stay on campus, over the telephone,
              and by making personal visits to the homes of the mentees assigned
              to the respective mentor.
            </p>
            <b>Areas covered include:</b>
            <div class="list">
              <ul>
                <li>1. Behavioral and discipline matters</li>
                <li>2. Health and physical well-being</li>
                <li>3. Achievements, talents, and co-curricular activities</li>
                <li>4. Stress-related issues</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="detgails-right-content">
            <div class="related-download">
              <h3>Related Downloads</h3>
              <ul>
                <li>
                  <a href="/vf/images/student_corner/mentor_mentee/Mentor_Mentee_Record_2022-23.pdf" target="_blank"
                    ><i class="flaticon-pdf-file"></i>Mentor-Mentee Record 2022-23</a
                  >
                </li>                
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="graduate-admission pt-8 pb-10">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="how-to-apply">
            <h3>Duties/Responsibilities of Mentor</h3>

            <div class="apply-list" style="padding-bottom: 80px">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <ul>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Introduce and
                      discuss the concept of the mentor-mentee system with the
                      assigned mentees.
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Call a meeting of
                      all mentees to record their necessary details in the
                      designated form, note any specific requirements of
                      students, and discuss the complete schedule of future
                      meetings.
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Keep track of
                      attendance, academic performance, and behavioral aspects
                      of students by interacting with the exam department and
                      hostel authorities, etc.
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Support students
                      academically and emotionally.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <img
            src="/vf/images/student_corner/mentor_mentee/4.png"
            alt="Image"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="graduate-admission pt-8 pb-10">
    <div class="container">
      <div class="row">
        <div class="col-lg-8">
          <div class="how-to-apply">
            <h3>Duties/Responsibilities of Mentee</h3>

            <div class="apply-list" style="padding-bottom: 100px">
              <div class="row">
                <div class="col-lg-12 col-md-12">
                  <ul>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Start Online
                      Submission
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Provide personal
                      information in the form at the time of joining the
                      mentor-mentee system.
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Provide details of
                      attendance, continuous assessment, term-end examinations,
                      co-curricular and extracurricular activities to the mentor
                      whenever requested.
                    </li>
                    <li>
                      <i class="ri-checkbox-circle-line"></i>Trust in the mentor
                      and seek advice whenever required.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <img
            src="/vf/images/student_corner/mentor_mentee/5.png"
            alt="Image"
          />
        </div>
      </div>
    </div>
  </div>
  <!--End Mentor-Mentee Area-->

  <!-- Start Bottom Connect Area -->
  <div class="alumni-interview-area pb-100">
    <div class="container">
      <div class="interview-content ptb-100">
        <div class="interview">
          <router-link href="/policies" class="default-btn btn"
            >Policies<i class="flaticon-next"></i
          ></router-link>
          <router-link to="/applynow" class="default-btn btn"
            >Apply Now</router-link
          >
        </div>
      </div>
    </div>
  </div>
  <!--End Bottom Connect Area -->
</template>

<script>
export default {
  name: "WDCView",
};
</script>
